import { createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { DirectorySetting } from './actions';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'directorySettings';

export interface State extends Status {
    data: DirectorySetting[];
}

export const initialState: State = {
    data: [],
    ...initialStatus,
};

export const reducer = createReducer(
    initialState,

    on(actions.loadDirectorySettingsSuccess, (state, action) => ({
        ...state,
        data: action.settings,
        error: false,
        loaded: true,
    })),
    on(actions.loadDirectorySettingsFailure, (state, { error }) => ({
        ...state,
        error,
        loaded: false,
    })),

    on(actions.updateDirectorySetting, actions.createDirectorySetting, (state) => ({
        ...state,
        updating: true,
        error: null,
    })),

    on(actions.updateDirectorySettingSuccess, (state, action) => ({
        ...state,
        data: action.settings,
        updating: false,
        error: false,
    })),

    on(actions.updateDirectorySettingFailure, (state, { error }) => ({
        ...state,
        error,
        updating: false,
    })),
);

export const selectAll = (state: State) => state.data;
export const selectError = (state: State) => state.error;
